import { schoolInitials } from "./hostSchool";

/**
 * Visibility for the event-header host-school band.
 *
 * - Guests: only the host's configured school (internal rsvp.dance link or external URL).
 * - Host: same school promo when configured; otherwise a setup prompt (never shown to guests).
 * - Opt-out / missing destination for guests: hidden.
 */
export function resolveHostSchoolPromoView({
  hostSchool,
  hostSchoolOptOut = false,
  isHosting = false,
} = {}) {
  if (hostSchoolOptOut) return { type: "hidden" };
  if (hostSchool?.name && hostSchool?.href) {
    return {
      type: "promo",
      kind: hostSchool.kind === "external" ? "external" : "internal",
      name: hostSchool.name,
      href: hostSchool.href,
      initials: schoolInitials(hostSchool.name),
      isExternal: hostSchool.kind === "external",
    };
  }
  // Setup CTA is host-only — guests never see an empty/prompt state here.
  if (isHosting) return { type: "setup" };
  return { type: "hidden" };
}
